module.exports = __webpack_public_path__ + "img/care-mitr.5dc9cedc.svg";